import React from 'react'
import PropTypes from 'prop-types'
import LinksList from '../links-list'
import {useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'

const LinkColumn = ({variant, linkGroupSchema}) => {
    const styles = useMultiStyleConfig('Footer')

    return (
        <>
            {linkGroupSchema.map(({column_title = '', links = []}, index) => (
                <LinksList
                    key={index}
                    {...styles.policies}
                    variant={variant}
                    columnTitle={column_title}
                    links={links}
                />
            ))}
        </>
    )
}

LinkColumn.propTypes = {
    variant: PropTypes.oneOf(['vertical', 'horizontal']),
    linkGroupSchema: PropTypes.arrayOf(
        PropTypes.shape({
            column_title: PropTypes.string, // Optional if required
            links: PropTypes.arrayOf(
                PropTypes.shape({
                    link: PropTypes.shape({
                        title: PropTypes.string,
                        href: PropTypes.string,
                    }),
                    is_external_url: PropTypes.bool,
                }),
            ),
        }),
    ).isRequired,
}

export default LinkColumn
